import Text from '@common/components/common/Text'
import ReviewsGrid from '@common/components/ReviewsGrid'
import {useTypedSelector} from '@common/hooks/useTypedSelector'
import {IReviewsItem} from '@common/types'
import Step from '@components/PageStep'

export const Expertise = () => {
  const {expertisePage} = useTypedSelector(state => state.expertise)

  return (
    <>
      <section className="inner-title">
        <div className="container">
          <h1 className="inner-title__text">
            <Text text={expertisePage?.title} />
          </h1>
        </div>
      </section>
      <section className="inner-grid inner-grid--no-padding">
        <div className="container">
          <ReviewsGrid
            type="services"
            reviews={
              (expertisePage?.industries?.map((i: any) => ({
                slug: i.link,
                title: i.title,
                description: i.description,
                color: i.color,
                cardType: i.cardType
              })) as IReviewsItem[]) || []
            }
          />
        </div>
        {expertisePage?.steps?.map((item: any, index: number) => (
          <Step
            key={`step_${index}`}
            count={item.count}
            step={item.step}
            classNames={['inner-grid--margin-bottom']}
            stepChildren={item.children}
          />
        ))}
      </section>
    </>
  )
}
